import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const OrderIndex = () => import("@/views/pages/order/Index");
const OrderDetail = () => import("@/views/pages/order/Details");
const BatchIndex = () => import("@/views/pages/batch/Index");
const BatchDetail = () => import("@/views/pages/batch/Details");
const BatchCreate = () => import("@/views/pages/batch/components/createBatch/CreateBatchPanel.vue");
const HomeIndex = () => import("@/views/pages/home/Index");
const ReportIndex = () => import("@/views/pages/report/Index");
const PointIndex = () => import("@/views/pages/point/Index");
const CustomerIndex = () => import("@/views/pages/customer/Index");

const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresIsLogin: true },
    },
    {
      path: "/d-order",
      name: "d-order",

    },
    {
      path: "/d-chatbot",
      name: "d-chatbot",

    },
    // {
    //   path: "/batch",
    //   redirect: "/batch",
    //   name: "รายการแบทช์",
    //   component: TheContainer,
    //   meta: { requiresAuth: true, lv: 1, activeUrl: "/batch" },
    //   children: [
    //     {
    //       path: "batch",
    //       redirect: "/batch",
    //       name: "",
    //       component: {
    //         render(c) {
    //           return c("router-view");
    //         },
    //       },
    //       children: [
    //         {
    //           path: "",
    //           name: "รายการแบทช์คลังสินค้า",
    //           component: BatchIndex,
    //           meta: {
    //             requiresAuth: true,
    //             isChildren: true,
    //             activeUrl: "/batch",
    //             lv: 2,
    //           },
    //         },
    //         {
    //           path: "details/:id",
    //           name: "รายละเอียดแบทช์คลังสินค้า",
    //           component: BatchDetail,
    //           meta: {
    //             requiresAuth: true,
    //             isChildren: true,
    //             activeUrl: "/batch",
    //             lv: 2,
    //           },
    //         },
    //         {
    //           path: "create-batch/:id",
    //           name: "รายการธุรกรรมใหม่",
    //           component: BatchCreate,
    //           meta: {
    //             requiresAuth: true,
    //             isChildren: true,
    //             activeUrl: "/batch",
    //             lv: 2,
    //           },
    //         },
    //       ],
    //     },
    //     {
    //       path: "order",
    //       redirect: "/order",
    //       name: "",
    //       component: {
    //         render(c) {
    //           return c("router-view");
    //         },
    //       },
    //       children: [
    //         {
    //           path: "",
    //           name: "รายการคำสั่งซื้อ",
    //           component: OrderIndex,
    //           meta: {
    //             requiresAuth: true,
    //             isChildren: true,
    //             activeUrl: "/batch",
    //             lv: 2,
    //           },
    //         },
    //         {
    //           path: "details/:id",
    //           name: "รายละเอียดคำสั่งซื้อ",
    //           component: OrderDetail,
    //           meta: {
    //             requiresAuth: true,
    //             isChildren: true,
    //             activeUrl: "/batch",
    //             lv: 2,
    //           },
    //         },
    //       ],
    //     },
    //   ],

      //   {
      //     path: "404",
      //     name: "Page404",
      //     component: Page404,
      //   },
      //   {
      //     path: "500",
      //     name: "Page500",
      //     component: Page500,
      //   },
      // ],
    // },
    {
      path: "/",
      redirect: "/home",
      name: "หน้าแรก",
      component: TheContainer,
      meta: { requiresAuth: true, lv: 1, activeUrl: "/home" },
      children: [
        {
          path: "home",
          redirect: "/home",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "หน้าขาย",
              component: HomeIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/batch",
                lv: 2,
              },
            },
            // {
            //   path: "details/:id",
            //   name: "รายละเอียดแบทช์คลังสินค้า",
            //   component: BatchDetail,
            //   meta: {
            //     requiresAuth: true,
            //     isChildren: true,
            //     activeUrl: "/batch",
            //     lv: 2,
            //   },
            // },
            // {
            //   path: "create-batch/:id",
            //   name: "รายการธุรกรรมใหม่",
            //   component: BatchCreate,
            //   meta: {
            //     requiresAuth: true,
            //     isChildren: true,
            //     activeUrl: "/batch",
            //     lv: 2,
            //   },
            // },
          ],
        },
        {
          path: "report",
          redirect: "/report",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ประวัติการสั่งซื้อ",
              component: ReportIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/report",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "point",
          redirect: "/point",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ประวัติการสั่งซื้อ",
              component: PointIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/point",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "customer",
          redirect: "/customer",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ประวัติการสั่งซื้อ",
              component: CustomerIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/customer",
                lv: 2,
              },
            },
          ],
        },
      ],

      //   {
      //     path: "404",
      //     name: "Page404",
      //     component: Page404,
      //   },
      //   {
      //     path: "500",
      //     name: "Page500",
      //     component: Page500,
      //   },
      // ],
    },
  ],
});
